import { useQuery } from "@tanstack/react-query";

import { useContainer } from "@contexts/container-context";
import { useCurrentUser } from "@hooks/queries/account";

export const useDeviceLastOnlineEnabled = (options = {}) => {
  const { organizationService } = useContainer();
  const currentUser = useCurrentUser();
  const orgCode = currentUser?.organizationCode;

  return useQuery({
    queryKey: ["deviceLastOnlineEnabled", orgCode],
    queryFn: () => organizationService.getDeviceLastOnlineEnabled(),
    enabled: !!orgCode,
    ...options,
  });
};
